<!-- <div class="year-controls" *ngIf="yearsControl">
    <button class="dp year-arrow" (click)="decrementYear()">&lt;</button>
    <button class="dp year">{{date.getFullYear()}}</button>
    <button class="dp year-arrow" (click)="incrementYear()">&gt;</button>
</div> -->
<!-- <div class="month-controls" *ngIf="monthsControl">
    <button class="dp month-arrow" (click)="decrementMonth()">&lt;</button>
    <button class="dp month">{{months[date.getMonth()]}}</button>
    <button class="dp month-arrow" (click)="incrementMonth()">&gt;</button>
</div> -->
<div class="month-controls" *ngIf="monthsControl">
    <button
        class="dp month-arrow"
        (click)="decrementMonth()"
        (keydown.enter)="decrementMonth()"
        (keydown.space)="decrementMonth()"
        attr.aria-label="{{ 'DATE_PICKER_PREVIOUS_MONTH' | translate }}"
        (keydown)="handleKeydown($event)"
        tabindex="-1"
        type="button"
        #control
    >
        <span class="icon icon-arrow-left"></span>
    </button>
    <button class="dp month" role="presentation">{{ months[date.getMonth()] | translate }}</button>
    <button
        class="dp month-arrow"
        (click)="incrementMonth()"
        (keydown.enter)="incrementMonth()"
        (keydown.space)="incrementMonth()"
        attr.aria-label="{{ 'DATE_PICKER_NEXT_MONTH' | translate }}"
        (keydown)="handleKeydown($event)"
        tabindex="-1"
        type="button"
        #control
    >
        <span class="icon icon-arrow-right"></span>
    </button>
</div>
